import { PropsWithChildren, isValidElement, cloneElement, ReactElement } from 'react';
import { IconProps } from '../icons/generated';

export interface ButtonIcon extends IconProps {
  children: ReactElement<IconProps>;
}

export const ButtonIcon = ({ size, color, children }: PropsWithChildren<ButtonIcon>) => {
  return isValidElement(children)
    ? cloneElement(children, {
        'color': children.props.color ?? color ?? 'currentColor',
        size,
        'aria-hidden': true,
        'focusable': false,
      })
    : null;
};
